import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { propertyListTitle } from "web_myplann/Portfolio/Components/Redesign/ListItem/propertyListTitle";
import type { CategoryItem } from "web_myplann/Portfolio/Types/portfolioCategory";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const categoryItemTitle = (
	item: CategoryItem,
	t: TranslateFunction,
): string =>
	item.kind === PortfolioItemKind.Property
		? propertyListTitle(item.data, t)
		: getPortfolioTitle(item.data, t);
